<h2 mat-dialog-title class="text">Upload A CSV File</h2>
<mat-dialog-content>
    <p class="text"><strong>Upload a 5 column CSV file that does not contain any headers!</strong></p>
    <input
        type="file"
        class="file-input"
        accept=".csv"
        (change)="onFileSelected($event)"
        #fileUpload
    >
    <div class="file-upload">
        <p id="fileName" class="text">{{fileName || "No file uploaded"}}</p>
        <button mat-fab class="upload-btn" (click)="fileUpload.click()"
        matTooltip="Upload a file">
            <mat-icon id="upload-icon" aria-label="Upload a File">file_upload</mat-icon>
        </button>
    </div>
</mat-dialog-content>
